import { Inline } from "PFComponents/containers";
import { Tile } from "PFComponents/tile";
import { useTranslation } from "react-i18next";

import { ActivitySummary } from "../../activity_summary/activity_summary";
import css from "./economics.module.scss";
import { EconomicsList } from "./economics_list/economics_list";

export const ActivityEconomics = () => {
  const { t } = useTranslation("activities");

  return (
    <Inline
      gap="spacingXl"
      className={css.root}
      alignItems="start"
      role="tabpanel"
      aria-label={t("show.tabs.economics")}
      qaId="ActivityPage.economicsTab"
    >
      <ActivitySummary />
      <Tile variant="light" paddingVariant="lg" className={css.activityEconomicsRightSide}>
        <EconomicsList />
      </Tile>
    </Inline>
  );
};
